import React from 'react'
import { useParams, Link } from 'react-router-dom'
import styles from '../../style'

const ProductDetail = ({products, logo}) => {
    const {id} = useParams()
    const product = products.find((p) => p.id === parseInt(id))

    if(!product) {
        return <p>Company Not Found</p>
    }

  return (
    <div className={`flex flex-col w-full ${styles.flexCenter}`}>
        <Link to="/Product" className={`flex flex-col gap-2 ${styles.flexCenter} mb-20`}>        
            <p className={`text-ss max-w-[480px] mt-5 text-center text-second`}>
                Scroll Back To Portfolio
            </p>
            <span className="border-r border-1 border-second h-[40px]"></span>
        </Link>
        <div className='flex flex-col justify-between'>
            <div className='flex flex-col gap-2 p-2'>
                {logo ? <img src={product.logo} alt="Company Logo" className="w-[20px] h-[20px] rounded-full object-cover"/> : <div className="w-[20px] h-[20px] rounded-full bg-secondary"></div>} 
                <p className="font-semibold text-md">{product.name}</p>         
            </div>
            <div className='flex flex-row gap-2 p-2'>
                <p className="font-semibold text-ss">{product.category}</p>
                <p className="font-semibold text-ss">{product.founders}</p> 
                <p className="font-semibold text-ss">{product.year}</p>          
            </div>
            <p className="font-semibold text-ss text-underline">{product.website}</p>
        </div>
        <img src={product.cover} alt={product.name} className="w-full h-[400px] object-cover hover:opacity-70"/> 
        <div className='flex flex-col ss:flex-row'>
            <p className="p-2 font-semibold text-md">{product.category}</p>
            <p className="p-2 font-semibold text-ss text-secondary max-w-[480px]">{product.details}</p>
        </div>
    </div>
  )
}
export default ProductDetail